import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import _ from 'lodash';
import ReactDragListView from 'react-drag-listview';

export default class AddChargeOptions extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            errors:{},
            selectedChargeType: '',
            defaultIdx:''
        };
        this._bind(
            'addClick'

        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {

    }

    componentWillMount() {

        this.setState({
            options: this.props.chargeOptions,
            selectedChargeType: this.props.selectedChargeType,
            defaultIdx:this.props.defaultIdx,
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null) {

            this.setState({
                    options: nextProps.chargeOptions,
                    selectedChargeType: nextProps.selectedChargeType,
                    defaultIdx: nextProps.defaultIdx
                });
        }
    }


    addClick(){
//// itemOptionName key can't have . & - in it for ex. Dr. Pepper and Dr - Pepper
        let self = this;

        let options = this.state.options;

        if(options.length >= 5){
            alert("You cannot add more than five options.")
            return;
        }

        console.log(JSON.stringify(options.length));

        this.setState(prevState => ({
            options: [...prevState.options, { name: "", var: 0,fixed: 0}]
        }),()=>{
            self.props.callBackAddOptions(self.state.options, this.state.defaultIdx);
        })
    }

    createUI(){
        return this.state.options.map((el, i) => (

           // let defaultOptionStatus = (this.state.defaultIdx == i) ? true : false

            <li key={i}>
                    <div className="row form-group-options">
                        <div className="col-xs-1">
                            <a type="button" href="JavaScript:void(0);" className="btn-rearrange"><i className="fa fa-bars" aria-hidden="true"></i></a>
                        </div>
                        <div className="col-xs-4">
                            <input type="text" className="form-control" required={true} placeholder="Option Label" name="name" value={el.name}
                                   onChange={this.handleChange.bind(this, i)}/>
                            <small className="form-text text-muted">Option Label</small>
                        </div>
                        <div className="col-xs-2">
                            <input type="tel" pattern="^-?[0-9]\d*\.?\d*$" className="form-control" required={false} placeholder="Percentage (%)" name="var" value={el.var}
                                   onChange={this.handleChange.bind(this, i)}/>
                           <small className="form-text text-muted">Percentage (%)</small>
                        </div>
                        <div className="col-xs-2">
                            <input type="tel" pattern="^-?[0-9]\d*\.?\d*$" className="form-control" required={false} placeholder="Fixed Amount ($)" name="fixed" value={el.fixed}
                                   onChange={this.handleChange.bind(this, i)}/>
                            <small className="form-text text-muted">Fixed Amount ($)</small>
                        </div>
                        <div className="col-xs-2">
                            <label className="radio-inline">
                                <input type="checkbox" name="defaultOption" id="defaultOption" checked={(this.state.defaultIdx === i) ? true : false} onClick={this.handleChange.bind(this, i)} />
                            </label><br/>
                            <small className="form-text text-muted">Default Select</small>
                        </div>
                        <div className="col-xs-1">
                            {
                                (this.state.selectedChargeType == "optional") ? (
                                    <button type="button" className="btn btn-danger btn-md" onClick={this.removeClick.bind(this, i)}><i className="fa fa-remove" aria-hidden="true"></i></button>
                                ) : null
                            }
                        </div>
                    </div>
            </li>
        ))
    }

    handleChange(i, e) {

        let self = this;
        const { name, value } = e.target;

        if (name == 'var') {
            let validNumber = new RegExp(/^\d*\.?\d*$/);
            if (!validNumber.test(value)) {
                let error = "Percentage format is wrong. It must be a numerical value like 2";
                alert(error);
                // console.log(error);
                let errors = {};
                errors["errors"] = error;
                this.setState({errors: errors});
                return
            }
        }

        if (name == 'fixed') {
            let validNumber = new RegExp(/^\d*\.?\d*$/);
            if (!validNumber.test(value)) {
                let error = "Fixed amount format is wrong. It must be a numerical value like" +
                    " $2.00";
                alert(error);
                // console.log(error);
                let errors = {};
                errors["errors"] = error;
                this.setState({errors: errors});
                return
            }
        }

        let defaultIdx = null;
        if (name == 'defaultOption'){

            let defaultStatus = e.target.checked;

            if(defaultStatus){
                defaultIdx = i;
            }
            else {
                defaultIdx = null;
            }
        }
        else {
            defaultIdx = this.state.defaultIdx;
        }


        let options = [...this.state.options];
        options[i] = {...options[i], [name]: value};
        this.setState({
            options: options,
            errors:{}
        },()=>{
            self.props.callBackAddOptions(self.state.options, defaultIdx);
        });

    }

    removeClick(i){

        let defaultIndex = this.state.defaultIdx;
        if (i <= this.state.defaultIdx ){
            defaultIndex = null;
        }

        let self = this;
        let options = [...this.state.options];
        options.splice(i, 1);
        this.setState({ options },()=>{
            self.props.callBackAddOptions(self.state.options, defaultIndex);
        });

    }

    render() {
        const self = this;
        const dragProps = {
            onDragEnd(fromIndex, toIndex) {
                const options = [...self.state.options];
                const item = options.splice(fromIndex, 1)[0];
                options.splice(toIndex, 0, item);
                self.setState({ options },()=>{
                    self.props.callBackAddOptions(self.state.options);
                });
            },
            nodeSelector: 'li',
            handleSelector: 'a'
        };
        return (
            <div>
                {/*onSubmit={this.handleSubmit}*/}
                <div className="row">
                    {
                        this.state.errors && this.state.errors["errors"] ? (
                            <div className="alert alert-danger text-center" role="alert">
                                <span className="form-text">{this.state.errors["errors"]}</span>
                            </div>) : null

                    }
                    {
                        (this.state.selectedChargeType == "optional") ? (
                            <button type="button" className="btn btn-success btn-sm float-right" onClick={this.addClick.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> Add Options
                            </button>
                        ) : null
                    }

                </div>
                <div className="row col-lg-12">
                <ReactDragListView {...dragProps}>
                    <ul className="add-options-ul">
                {this.createUI()}
                    </ul>
                </ReactDragListView>
                </div>
                {/*<input type="submit" value="Submit" />*/}
            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/custom-charges/add-charge-options.js